import React, { useState, useEffect, useRef} from 'react';
import { useParams,useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import axios from 'axios';
import { apiUrl } from './UrlParam.js';
//import { GanttComponent , DayMarkers, HolidaysDirective, Inject, HolidayDirective } from '@syncfusion/ej2-react-gantt';
import "../assets/css/styles.table.css"
 
import '../App.css';
import AxiosFetchData from './AxiosFetchData.js'
import { setValue } from '@syncfusion/ej2-base';
 
import { DialogFormTemplate } from './template';
import { ColumnDirective, ColumnsDirective, TreeGridComponent,RowDD,Inject , Aggregate, AggregatesDirective } from '@syncfusion/ej2-react-treegrid';
import { Edit, Toolbar, AggregateColumnDirective, AggregateColumnsDirective, AggregateDirective  } from '@syncfusion/ej2-react-treegrid';
import { getValue } from '@syncfusion/ej2-base';
 
import VirtualizedSelect from 'react-virtualized-select';
import DatePicker from 'react-datepicker'; 
import { getObject } from '@syncfusion/ej2-grids';
import Layout from './Layout.js';
import Helper from './Helper.js';
import PrintPreview from '../components/PrintReviewV3.js';
import Radio, { RadioProps } from '@mui/material/Radio';
import Input from '@mui/material/Input';
import {InvoiceHook,usePaymentTerm,usePayTerm} from '../hook/InvoiceHook.js';
import MainPrint from './MainPrint.js';
import {useAddInvoicesHook} from '../hook/AddInvoicesHook.js'

 
const AddInvoiceV3 =   () => {
    const { id,id2 } = useParams();
    //const [rows, setRows] = useState([]);
    const [treegrid,settreegrid] = useState(null)
   // var treegrid;
    //const Navigate = useNavigate();
    const {message,setmessage,type,setType,AddParentTask,roleAccess,handlePreview,persentase,handleTotal,setInvNoCustom,
      setPersentase,setTotal,setRetensi,InvoiceType,pph,setPph,pphValue,setPphValue,selectedValue,handleChange,
      invNoCustom,invNo,customer,setCustomer,isCustomer,paymentTermList,handleSelectedPaymentTerm,selectedOptionPaymentTerm,
      selectedDate,selectedDueDate,description,setDescription,rows,editOptions,toolbarOptions,settings,priceTemplate,TotalTemplate,customAggregateFn,
      custom1,custom5,custom,custom2,custom3,open,setOpen,treedata,setInvoiceType,setSelectedDate,setSelectedDueDate,actionBegin,actionComplete,selectionSettings,toolbarClick,rowDrop} = useAddInvoicesHook(id,id2,treegrid)
 
 const productTypeColTemplate = (props) => {
        if(getObject('product_type', props) == 1){
          return "Material"
        }

        if(getObject('product_type', props) == 2){
          return "Service"
        }

        if(getObject('product_type', props) == 0){
          return ""
        }
        
  };

return (
      <Layout message={message} setmessage={setmessage} tipe={type} settipe={setType}>
      <div className='pd'><b>ADD INVOICE</b> </div>
      <div className="pd"  >
           <div style={{display:"flex", width:"100%"}}>
              <div style={{marginTop:5,marginBottom:10, width:"50%"}}>
                <button onClick={() => AddParentTask()} className='btn btn-primary' disabled={!roleAccess.CREATE} style={{width:150}}>SAVE</button> 
              </div>
              <button onClick={() => handlePreview()} className='btn btn-primary' id="btnPreview" style={{display:'none'}}>SAVE</button> 
            </div>
          
            <div className="container-form">
              <div className="column-form" > 
                  <label>INV</label><hr style={{backgroundColor:'gray',height:0.3}}></hr>
                  <div style={{display: 'flex'}}>
                    <div className='col-lg-6' >
                      <input
                        type="number"
                        value={persentase == '' ? 0 : persentase}
                        name="address"
                        min ={0}
                        max = {100}
                        onChange={async (e) => await handleTotal(e.target.value)}
                        className='form-control'
                        required
                        style={{width: '100%'}}
                     />
                    </div>
                    <div className='col-lg-6'>
                        <VirtualizedSelect 
                                       options={[{label : 'Percent (%)', value: 'Percent'},{label : 'Nominal (Rp)', value: 'Nominal'}]}
                                       //onChange={(option) => setSelectedOptionPayment(option)}
                                       onChange={   (option) => {setInvoiceType(option.value); setPersentase(0); setTotal(0); setRetensi(0)}}
                                       value={InvoiceType}
                                       clearable={false}
                                       searchable={true}
                                       required
                                       
                                       width={"100%"}
                                       fullWidth
                                    />
                  </div>
                 
                  </div>
                  <br></br>
                  <label>PPH (fill with 0 if not using PPh)</label><hr style={{backgroundColor:'gray',height:0.3}}></hr>
                  <div style={{display: 'flex'}}>
                  <div className='col-lg-3' >
                      <input
                        type="number"
                        value={pph}
                        name="PPH"
                        min ={0}
                        max = {100}
                        onChange={  (e) =>   setPph(e.target.value)}
                        className='form-control'
                        required
                        style={{width: '100%'}}
                     />
                    </div>
                    <div className='col-lg-1' style={{textAlign:'left', paddingTop:9,paddingLeft:0}}>%</div>
                    <div className='col-lg-1' style={{textAlign:'left', paddingTop:9,paddingRight:0}}>Rp</div>
                    <div className='col-lg-7'>
                    <input
                        type="number"
                        value={pphValue}
                        name="pphValue"
                        min ={0}
                        max = {100}
                        onChange={  (e) => setPphValue(e.target.value)}
                        className='form-control'
                        required
                        style={{width: '100%'}}
                     />
                  </div>
                 
                  </div>
                </div>

                <div className="column-form"> 
                <label>INV NO</label><hr style={{backgroundColor:'gray',height:0.3}}></hr>
                    
                    <div style={{fontSize:9,marginTop:0,marginLeft:0}}><i><b><u>By manual:</u></b></i></div>
                    <div style={{display:'flex'}}>
                        <Radio
                          checked={selectedValue === 'custom'}
                          onChange={handleChange}
                          value="custom"
                          name="radio-buttons"
                          inputProps={{ 'aria-label': 'A' }}
                          disabled={isCustomer}
                        />
                         <Input
                            value={invNoCustom}
                            fullWidth 
                            onChange={(e) => {
                                  setInvNoCustom(e.target.value)
                            }}
                            disabled={selectedValue === 'system' ? true : false}
                            style={{width:"100%", height:20, marginTop:8}}
                            placeholder='NR00000-0/MS/{CUSTOMER}/MM/YYYY'
                          />
                    </div>
                    <div style={{fontSize:9,marginTop:20,marginLeft:0}}><i><b><u>By system:</u></b></i></div>
                    <div style={{display:'flex'}}>
                        <Radio
                          checked={selectedValue === 'system'}
                          onChange={handleChange}
                          value="system"
                          name="radio-buttons"
                          inputProps={{ 'aria-label': 'A' }}
                        />
                        <div style={{display: 'flex'}}>
                          <span style={{fontSize:11, marginTop:10}}>{invNo.split('/')[0]}/MS/&nbsp;</span>
                          <input
                            type="text"
                            value={customer}
                            name="inNo"
                            onChange={(e) => setCustomer(e.target.value)}
                            className='form-control'
                            style={{width:100, height:17, marginTop:10, fontSize:8}}
                            required
                            disabled={selectedValue === 'custom' ? true : isCustomer}
                           // disabled={isCustomer}
          
                            />&nbsp;
                            <span style={{fontSize:11, marginTop:10}}>/ {invNo.split('/')[3]} /{invNo.split('/')[4]} </span>
                        </div>
                    </div>
                {/* <div>
                <input
                        type="text"
                        value={customer}
                        name="inNo"
            
                        onChange={(e) => setCustomer(e.target.value)}
                      
                        className='form-control'
                        style={{width:100, height:25}}
                        required
                        disabled={isCustomer}
                       // style={{margin:5}}
                    />
                </div> */}
                </div>

                
          </div>
          < div className="container-form">
                <div className="column-form"> 
                <label >Payment Term</label><hr style={{backgroundColor:'gray',height:0.3}}></hr>
                <VirtualizedSelect
                                        options={paymentTermList}
                                        onChange={(option) => handleSelectedPaymentTerm(option)}
                                        value={selectedOptionPaymentTerm}
                                        clearable={false}
                                        searchable={true}
                                        required
                                       
                                    />
                <div>Date</div>
                <DatePicker 
                    showIcon
                    selected={selectedDate}
                    onChange={(date) => setSelectedDate(date)}
                   // disabled={!roleAccess.UPDATE}
                    dateFormat="dd-MM-yyyy"
                   
                    className="form-control"/>
 
                <div style={{marginTop:10}}>Due Date</div>
                <DatePicker 
                    showIcon
                    selected={selectedDueDate}
                     onChange={(date) => setSelectedDueDate(date)}
                   // disabled={!roleAccess.UPDATE}
                    dateFormat="dd-MM-yyyy"
                    className="form-control"/>
                </div>
                <div className="column-form"> 
                <label >Note</label><hr style={{backgroundColor:'gray',height:0.3}}></hr>
                  {/* <input
                    type="text"
                    value={description}
                    name="address"
                    onChange={(e) => setDescription(e.target.value)}
                    placeholder="Enter the purchase No."
                    className='form-control'
                    fullWidth
                    required
                    style={{margin:5}}
                  /> */}
                  <textarea
                   
                   type="text"
                   value={description}
                   name="address"
                   rows={8}
                   onChange={(e) => setDescription(e.target.value)}
                   placeholder="Enter the note."
                   className='form-control'
                   fullWidth
                   required
                   
                 />
                </div>
          </div>
           
            <div>
              <TreeGridComponent dataSource={rows} treeColumnIndex={1} childMapping='subChild' height='100%'   enableCollapseAll={false}   editSettings={editOptions} toolbar={toolbarOptions} ref={g => settreegrid(g)} actionBegin={actionBegin} actionComplete={actionComplete} allowRowDragAndDrop={true} selectionSettings={selectionSettings} rowDrop={rowDrop.bind(this)} toolbarClick={toolbarClick} allowTextWrap={true} textWrapSettings={settings}>
                 <ColumnsDirective>
                    {/* <ColumnDirective field='rowNumber' headerText='No' width='70' textAlign='Left'  /> */}
                    <ColumnDirective field='po_detail_id' headerText='ID' width='50' textAlign='Right' isPrimaryKey={true}  visible={false}/>
                    <ColumnDirective field='part_no' headerText='Part No.' width='200'/>
                    <ColumnDirective field='descriptions' headerText='Description' width='300'  textAlign='Left' />
                    <ColumnDirective field='newqty' headerText='Qty' width='100'  textAlign='Right' />
                    <ColumnDirective field='unit_name' headerText='Unit' width='100'  textAlign='Right' />
                    <ColumnDirective headerText='Product Type' width='150'  textAlign='Right' template={productTypeColTemplate} />
                    <ColumnDirective field='price' headerText='Price' width='120'  textAlign='Right' valueAccessor={priceTemplate}/>
                    <ColumnDirective field='total' headerText='Total' width='300' template={TotalTemplate} textAlign='Center'/>
                    <ColumnDirective field='code' headerText='Code' width='350'  textAlign='Left' visible={false}/>
                    <ColumnDirective field='rev' headerText='Rev' width='350'  textAlign='Left' visible={false}/>
                    <ColumnDirective field='type' headerText='type' width='50'  textAlign='Left' visible={false}/>
{/*                     
                    <ColumnDirective field='Action 1' headerText='Add Parent' width='120' textAlign='Right'/>
                    <ColumnDirective field='Action 2' headerText='Add Sub' width='100' textAlign='Right'/>
                    <ColumnDirective field='Edit' headerText='Edit Task' width='80' textAlign='Right'/>
                    <ColumnDirective field='Delete' headerText='Delete Task' width='100' textAlign='Right'/> */}
                </ColumnsDirective>
                <AggregatesDirective>
                <AggregateDirective showChildSummary={false}>
                    <AggregateColumnsDirective>
                    <AggregateColumnDirective field='total' columnName='total' type='Custom' customAggregate={customAggregateFn} footerTemplate={custom1}/>
                     
                    </AggregateColumnsDirective>
                </AggregateDirective>
                
                <AggregateDirective showChildSummary={false}>
                    <AggregateColumnsDirective>
                    <AggregateColumnDirective field='total' columnName='total' type='Custom'   footerTemplate={custom5}/>
                     
                    </AggregateColumnsDirective>
                </AggregateDirective>  
                <AggregateDirective showChildSummary={false}>
                    <AggregateColumnsDirective>
                    <AggregateColumnDirective field='total' columnName='total' type='Custom' customAggregate={customAggregateFn} footerTemplate={custom}/>
                     
                    </AggregateColumnsDirective>
                </AggregateDirective>
                <AggregateDirective showChildSummary={false}>
                    <AggregateColumnsDirective>
                    <AggregateColumnDirective field='total' columnName='total' type='Custom'   footerTemplate={custom2}/>
                     
                    </AggregateColumnsDirective>
                </AggregateDirective>
                <AggregateDirective showChildSummary={false}>
                    <AggregateColumnsDirective>
                    <AggregateColumnDirective field='total' columnName='total' type='Custom'   footerTemplate={custom3}/>
                     
                    </AggregateColumnsDirective>
                </AggregateDirective>
                </AggregatesDirective>
                <Inject services={[Edit, Toolbar, RowDD, Aggregate]}/>
            </TreeGridComponent>;
            </div>
            
    </div>
      <PrintPreview id={id} id2={id2} open={open} setopen={setOpen}  >
            {treedata}
      </PrintPreview>
 </Layout>

       
    );
}
 

export default AddInvoiceV3;